import router from '../../router'
import Theme01 from '../../router/Theme01'
import Theme03 from '../../router/Theme03'
import MyStore from '../../views/MyStore'

export default {
  'PUSH_MSG' (state, payload) {
    state.EnbMsg.push({
      id: Math.round(Math.random() * 1000000),
      msg: payload.msg,
      color: payload.color
    })
  },
  'DEL_MSG' (state, payload) {
    state.EnbMsg = state.EnbMsg.filter(m => m.id !== payload)
  },
  'GET_LOGIN' (state, payload) {
    localStorage.setItem('user', JSON.stringify(payload))
    state.Profile = payload
  },
  'GET_LOGOUT' (state) {
    localStorage.removeItem('user')
    localStorage.removeItem('client')
    state.Profile = {}
  },
  'PUSH_MULTI_SELECT' (state, payload) {
    console.log(payload)
    if(typeof state[payload.store] === 'undefined') {
      state[payload.store] = []
    }
    state[payload.store].push(payload.data)
  },
  'DEL_MULTI_SELECT' (state, payload) {
    let newList = state[payload.store].filter(i => i.id !== payload.data.id)
    state[payload.store] = newList
  },
  'SET_MULTI_SELECT' (state, payload) {
    state[payload.store] = payload.list
  },
  'CHANGE_USER_EDIT' (state, payload) {
    for(let key in payload) {
      state.SelectedUserEdit[key] = payload[key]
    }
  },
  'CHANGE_USER_PERMISSION' (state, payload) {
    if(!payload.active) {
      state.SelectedUserEdit.permissao.push(payload.id)
      console.log(state.SelectedUserEdit.permissao)
    }
    else {
      state.SelectedUserEdit.permissao = state.SelectedUserEdit.permissao.filter(i => i !== payload.id)
      console.log(state.SelectedUserEdit.permissao)
    }
    state.Permission.map(p => {
      if(payload.id === p.id) {
        p.active = !payload.active
      }
    })
  },
  'PUSH_USER' (state, payload) {
    state.Users.push(payload)
  },
  'UPDATE_USER' (state, payload) {
    state.Users.map(u => {
      if(u.id === payload.payload.id) {
        u = payload.payload
        u.status = payload.status
      }
    })
  },
  'DELETE_USER' (state, payload) {
    state.Users = state.Users.filter(u => u.id !== payload.id)
  },
  'SET_USER_EDIT' (state, payload) {
    state.SelectedUserEdit = payload
    state.SelectedUserEdit.permissao.map(n => {
      state.Permission.filter(p => p.id === n)[0].active = true
    })
  },
  'CLEAR_USER_EDIT' (state) {
    state.SelectedUserEdit = {
      usuario: '',
      nome: '',
      sobrenome: '',
      email: '',
      senha: '',
      permissao: []
    }
  },
  'CHANGE_THEME' (state, payload) {
    let routeThemes = { Theme01, Theme03 }
    let selectedTheme = state.Themes.filter(t => t.name === payload)[0]
    state.Themes.map(t => {
      t.active = false
      if (t.name === payload) {
        t.active = true
      }
    })
    router.addRoute({
      name: 'Minha Loja',
      path: '/',
      component: MyStore,
      children: routeThemes[selectedTheme.route]
    })
    router.addRoute({
      name: 'Minha Loja',
      path: '/loja',
      component: MyStore,
      children: routeThemes[selectedTheme.route]
    })
    state.Theme = selectedTheme
  },
  'TOGGLE_SEARCH_LOAD' (state, payload) {
    state.SearchLoad = payload
  },
  'UPDATE_LOGO' (state, payload) {
    state.Logo = payload
  },
  'UPDATE_FONT_DEFAULT' (state, payload) {
    state.Prefes.global.font = payload
  },
  'UPDATE_PREF_COMP' (state, payload) {
    if(!state.Prefes[payload.comp]) {
      state.Prefes[payload.comp] = {}
    }
    state.Prefes[payload.comp][payload.prop] = payload.value
  },
  'GET_USER' (state, payload) {
    if(payload.init) {
      state.Users = payload.payload
    }
    else {
      state.Users = state.Users.concat(payload.payload)
    }
  },
  'SET_EMPRESA' (state, payload) {
    state.Empresa = payload
    state.Logo = payload.logo
  },
  'LOAD_PREFES' (state, payload) {
    let Prefes = {}
    for(let key in payload) {
      Prefes[payload[key].comp] = {}
    }
    for(let key in payload) {
      Prefes[payload[key].comp][payload[key].prop] = payload[key].valor
    }
    console.log(Prefes)
    state.Prefes = Prefes
  },
  'LOADING' (state, payload) {
    state.Loading = payload
  },
  'SET_USERVALIDATE' (state, payload) {
    for(let key in payload) {
      state.UserValidate[key] = payload[key]
    }
  },
  'CHANGE_EMPRESA' (state, payload) {
    for(let key in payload) {
      state.Empresa[key] = payload[key]
    }
  },
  'CHANGE_PWRECOVERY' (state, payload) {
    state.PWrecovery = payload
  }
}
